<template>
  <Modal name="DELETE_ITEM_PRICE_MODAL" :title="title" actions>
    <template v-slot:body>
      <p>{{ $t('itemPrice.hints.delete') }}</p>
      <v-card class="pa-5 mt-5 grey lighten-3" outlined>
        <v-progress-linear v-if="isItemPriceLoading" indeterminate />
        <span v-else>
          <!-- {{ itemPrice ? itemPrice.name : '---' }} -->
          <h6 class="grey--text text-uppercase">
            {{ $t('itemPrice.label.name') }}
          </h6>
          <p class="mb-2">
            {{ itemPrice.item.name }}
          </p>
          <v-row no-gutters>
            <v-col>
              <h6 class="grey--text text-uppercase">
                {{ $t('itemPrice.label.basePrice') }}
              </h6>
              <p class="mb-2">
                {{
                  itemPrice.base_price
                    ? formatMoney(itemPrice.base_price)
                    : '---'
                }}
              </p>
            </v-col>
            <v-col>
              <h6 class="grey--text text-uppercase">
                {{ $t('itemPrice.label.comboPrice') }}
              </h6>
              <p class="mb-2">
                {{
                  itemPrice.combo_price
                    ? formatMoney(itemPrice.combo_price)
                    : '---'
                }}
              </p>
            </v-col>
          </v-row>
        </span>
      </v-card>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeAllModals"
        :disabled="isItemPriceLoading"
        class="mr-5"
        large
        text
      >
        {{ $t('itemPrice.action.cancel') }}
      </v-btn>

      <v-btn
        @click="removeItemPrice(itemPrice.id)"
        :loading="isItemPriceLoading"
        class="red"
        large
        dark
        text
      >
        {{ $t('itemPrice.action.delete') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Modal from '@/components/app/Modal'

import { catalogMonetary } from '@/util/catalog'

export default {
  name: 'ItemPriceDelete',

  components: {
    Modal,
  },

  computed: {
    ...mapGetters(['itemPrice', 'isItemPriceLoading']),
  },

  data() {
    return {
      title: this.$t('itemPrice.action.delete'),
      formatMoney: catalogMonetary,
    }
  },

  methods: {
    ...mapMutations(['closeAllModals']),
    ...mapActions(['removeItemPrice']),
  },
}
</script>
